import apiClient from './apiClient';

export interface TrasferimentoRow {
  id: number | string;
  ufficio_nome: string;
  display_name?: string;
  area: string | null;
  location: string | null;
  giorno: string;
  fascia: string;
  apertura: string;
  chiusura: string;
  aggiornato_il?: string | null;
  is_static?: boolean;
}

export interface TrasferimentoCreatePayload {
  ufficio_nome: string;
  area?: string | null;
  location?: string | null;
  giorno: string;
  fascia: string;
  apertura: string;
  chiusura: string;
}

export interface TrasferimentoSyncResult {
  inserted: number;
  updated: number;
  skipped: number;
}

class OrariTrasferimentoService {
  async getAll(): Promise<TrasferimentoRow[]> {
    const res = await apiClient.get<TrasferimentoRow[]>('/api/orari-trasferimento');
    return res.data;
  }

  async sync(): Promise<TrasferimentoSyncResult> {
    const res = await apiClient.post<TrasferimentoSyncResult>('/api/orari-trasferimento/sync');
    return res.data;
  }

  async create(payload: TrasferimentoCreatePayload): Promise<TrasferimentoRow> {
    const res = await apiClient.post<TrasferimentoRow>('/api/orari-trasferimento', payload);
    return res.data;
  }

  async update(
    id: number,
    payload: Partial<Pick<TrasferimentoRow, 'apertura' | 'chiusura' | 'area' | 'location' | 'giorno' | 'fascia'>>,
  ): Promise<TrasferimentoRow> {
    const res = await apiClient.put<TrasferimentoRow>(`/api/orari-trasferimento/${id}`, payload);
    return res.data;
  }

  // Nome mostrato e detto al cittadino; stringa vuota = nome predefinito.
  async renameOffice(ufficio_nome: string, display_name: string): Promise<void> {
    await apiClient.put('/api/orari-trasferimento/ufficio', { ufficio_nome, display_name });
  }

  async delete(id: number): Promise<void> {
    await apiClient.delete(`/api/orari-trasferimento/${id}`);
  }
}

export const orariTrasferimentoService = new OrariTrasferimentoService();
